// apps/booth-web/src/i18n/locale.ts
import { DEFAULT_LOCALE, LOCALE_CODES, LOCALE_LABELS, type LocaleCode } from "@fiket/booth-schema";

/**
 * 키오스크 언어 — schema 의 LocaleCode 를 그대로 쓴다(테마·스타일 이름의 localizedName() 과 같은 코드).
 * zh 는 단일 코드(간체). zh-CN/zh-TW 분리는 요구가 생길 때.
 *
 * 코드·라벨·기본값의 출처는 schema `i18n.ts` 다 (BOOTH-116) — 콘솔의 부스 기본 언어 셀렉트와 같은 목록·라벨을 쓰도록
 * 여기서는 이름만 유지한 재export 로 둔다(키오스크 호출처 변경 없음).
 */
export type Language = LocaleCode;

export const LANGUAGES: readonly Language[] = LOCALE_CODES;
export const DEFAULT_LANGUAGE: Language = DEFAULT_LOCALE;

/** 헤더 세그먼트 라벨 — 네이티브 언어명. 결정 사연은 schema `LOCALE_LABELS` 주석 */
export const LANGUAGE_LABELS: Record<Language, string> = LOCALE_LABELS;
